import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminBlocklistedNameDto,
  AdminBlocklistedNameUpsertRequestDto,
  AdminMusicalInformationDto,
  AdminMusicalShowsInformationsDto,
  AdminReservationCreateRequestDto,
  AdminReservationDto,
  AdminReservationUpdateRequestDto
} from '../models/admin-api.model';
import { TenantConfigService } from './tenant-config.service';

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {
  private readonly http = inject(HttpClient);
  private readonly tenantConfigService = inject(TenantConfigService);

  private get baseUrl(): string {
    return this.tenantConfigService.getAdminBaseUrl();
  }

  getMusicalInfo(): Observable<AdminMusicalInformationDto> {
    return this.http.get<AdminMusicalInformationDto>(`${this.baseUrl}/shows/info`);
  }

  getShows(showsDateStart: string, showsDateEnd: string): Observable<AdminMusicalShowsInformationsDto> {
    const params = new HttpParams()
      .set('showsDateStart', showsDateStart)
      .set('showsDateEnd', showsDateEnd);

    return this.http.get<AdminMusicalShowsInformationsDto>(`${this.baseUrl}/shows`, { params });
  }

  getReservations(targetStartingDateUTC: string): Observable<AdminReservationDto[]> {
    const params = new HttpParams().set('targetStartingDateUTC', targetStartingDateUTC);
    return this.http.get<AdminReservationDto[]>(`${this.baseUrl}/reservations`, { params });
  }

  /*   createReservation(payload: AdminReservationCreateRequestDto): Observable<AdminReservationDto> {
      return this.http.post<AdminReservationDto>(`${this.baseUrl}/reservations`, payload);
    } */

  updateReservation(payload: AdminReservationUpdateRequestDto): Observable<AdminReservationDto> {
    return this.http.put<AdminReservationDto>(`${this.baseUrl}/reservations`, payload);
  }

  cancelReservation(processId: string, cancelledReason?: string): Observable<AdminReservationDto> {
    let params = new HttpParams();

    if (cancelledReason?.trim()) {
      params = params.set('cancelledReason', cancelledReason.trim());
    }

    return this.http.delete<AdminReservationDto>(
      `${this.baseUrl}/reservations/${processId}`,
      { params }
    );
  }

  /*   syncData(): Observable<void> {
      return this.http.post<void>(`${this.baseUrl}/sync`, {});
    } */

  getBlocklistNames(): Observable<AdminBlocklistedNameDto[]> {
    return this.http.get<AdminBlocklistedNameDto[]>(`${this.baseUrl}/blocklist-names`);
  }

  upsertBlocklistName(payload: AdminBlocklistedNameUpsertRequestDto): Observable<AdminBlocklistedNameDto> {
    return this.http.post<AdminBlocklistedNameDto>(`${this.baseUrl}/blocklist-names`, payload);
  }

  deleteBlocklistName(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/blocklist-names/${id}`);
  }
}